module.exports = __webpack_public_path__ + "img/banner.53e0a06e.png";